import urlconfig from "./url-config";

var mockConfig = {
  globalMock: false
};
mockConfig[urlconfig.loginCheckUrl] = {
  mock: true,
  mockFile: "user-login.json"
};
mockConfig[urlconfig.forgetPasswordUrl] = {
  mock: true,
  mockFile: "forget-password.json"
};
mockConfig[urlconfig.validateTokenUrl] = {
  mock: true,
  mockFile: "validate-token.json"
};
mockConfig[urlconfig.setTokenPasswordUrl] = {
  mock: true,
  mockFile: "set-token-password.json"
};
mockConfig[urlconfig.checkEmailExistUrl] = {
  mock: true,
  mockFile: "check-email-exist.json"
};
mockConfig[urlconfig.signupUrl] = {
  mock: true,
  mockFile: "user-signup.json"
};
mockConfig[urlconfig.logoutUrl] = {
  mock: true,
  mockFile: "user-logout.json"
};
mockConfig[urlconfig.metadataUrl] = {
  mock: true,
  mockFile: "metadata.json"
};

export default {};
